export const LoginLinkStyles = {
        textDecoration: "none",
        color: "#DF7A00"
    }
